module.exports = __webpack_public_path__ + "static/media/ic-diversification.5d3bf940.svg";